import { API_BASE_URL, SEND_EMAIL_NOTIFICATION_API_URL, SUBMIT_AWARDS_FORM_URL } from "../constants/Constants";
import { EnquiryFormModel } from "../models/EnquiryFormModel";

const headers = {
    "Accept": "application/json",
    "Content-type":"application/json"
}

function joinUrl(baseUrl:string,url:string){
    return `${baseUrl}/${url}`;
}
export class BackendApiServices{
    baseUrl = API_BASE_URL;

    sendEnquiryDataToBackend(dataEntry: EnquiryFormModel){
        let url = joinUrl(this.baseUrl,SUBMIT_AWARDS_FORM_URL);
        let method = "POST";
        let options:any = {
            headers,
            method
        }
        options.body = JSON.stringify({...dataEntry});
        return fetch(url,options)
    }

    senEmailNotification(dataEntry: EnquiryFormModel){
        let url = SEND_EMAIL_NOTIFICATION_API_URL;
        let method="POST";
        let options:any = {
            headers,
            method
        }
        options.body = JSON.stringify({...dataEntry});
        return fetch(url,options)
    }
}